import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detectBrowserLanguage from "detect-browser-language";

import en from "../../../../infrastructure/translate/en.json";
import es from "../../../../infrastructure/translate/es.json";
import pt from "../../../../infrastructure/translate/pt.json";
import esMX from "../../../../infrastructure/translate/es-MX.json";

const resources = {
  en: { translation: en },
  es: { translation: es },
  pt: { translation: pt },
  "es-MX": { translation: esMX },
};
const lang = detectBrowserLanguage();
const langTag = Object.keys(resources).find((langKey) => langKey === lang);

i18n.use(initReactI18next).init({
  lng: langTag,
  fallbackLng: ["es", "pt", "en", "es-MX"],
  resources,
  detection: {
    order: ["navigator"],
  },
});
